import _ from 'lodash';
import React, { useEffect } from 'react';
import AdvancedOptions from 'v2/modules/withRunForm/components/AdvancedOptions/index';
import ReferencesModalContainer from 'v3/quantConfig/reference/ReferencesModalContainer/index';
import Cases from 'v2/modules/withRunForm/components/Cases/index';
import ExpiryDetails from 'v2/modules/withRunForm/components/ExpiryDetails/index';
import FeatureEnablements from 'v2/modules/withRunForm/components/FeatureEnablements/index';
import InstrumentDetails from 'v2/modules/withRunForm/components/InstrumentDetails/index';
import OrderExecutionDetails from 'v2/modules/withRunForm/components/OrderExecutionDetails/index';
import OverallExitCondition from 'v2/modules/withRunForm/components/OverallExitCondition/index';
import PipeConfigs from 'v2/modules/withRunForm/components/PipeConfigs/index';

const QuantBuilder = () => {
  useEffect(() => {
    function onIntentsScroll() {
      $('.intents-container')
         
        .prop('scrollTop', this.scrollTop)
         
        .prop('scrollLeft', this.scrollLeft);
    }
    const debouncedOnIntentScroll = _.debounce(onIntentsScroll, 100);
    $('.intents-container').on('scroll', debouncedOnIntentScroll);
    return () => {
      $('.intents-container').off('scroll', debouncedOnIntentScroll);
    };
  }, []);

  return (
    <div className="card-wrapper ">
      <ReferencesModalContainer />
      <InstrumentDetails />
      <PipeConfigs />
      <FeatureEnablements />
      <Cases />
      <AdvancedOptions />
      <OverallExitCondition />
      <ExpiryDetails />
      <OrderExecutionDetails />
    </div>
  );
};

QuantBuilder.propTypes = {};
QuantBuilder.defaultProps = {};

export default QuantBuilder;
